// extracted by mini-css-extract-plugin
module.exports = {"AddButton":"Button_AddButton__3nkQr","RemoveButton":"Button_RemoveButton__3P41Q","ClearButton":"Button_ClearButton__11NNM","FavoriteButton":"Button_FavoriteButton__1ZpdO"};